import {ResearchLitElement, html, css, unsafeHTML} from '@core/research-lit-element';

import '@bog-design-system/bd-font';
import '@bog-design-system/bd-standard-button';
import '@bog-design-system/bd-video-player';
import '@bog-design-system/bd-package-card';
import '@bog-design-system/bd-section-template';
import '@bog-design-system/bd-list-item';
import '@bog-design-system/bd-icon';
import '@bog-design-system/bd-tabs';
import '@bog-design-system/bd-major-card';

import {BdModal} from '@bog-design-system/bd-modal';

import '../../common/layout/research-section.js';
import '../../common/research-product-promo-card.js';
import '../../common/research-card.js';
import '../../common/research-slider.js';
import '../../common/research-tab-selector.js';
import '../../common/faq/research-faq.js';
import '../../common/modals/research-info-modal.js';

class researchMain extends ResearchLitElement {
    static get is() {
        return 'research-main';
    }

    static get styles() {
        return css`
          .main-section {
            background: linear-gradient(to bottom, #e5e3fe, transparent, #fcfcfc);
            --section-space: var(--space-128);
            position: relative;
          }

          .head-1-img,
          .head-2-img,
          .head-3-img,
          .head-4-img {
            position: absolute;
            width: 80px;
          }

          .head-1-img {
            top: 428px;
            left: 468px;
          }

          .head-2-img {
            top: 100px;
            right: 330px;
          }

          .head-3-img {
            top: 102px;
            left: 358px;
          }
          
          .head-4-img {
            top: 410px;
            right: 484px;
          }

          .research-card-container {
            display: flex;
            justify-content: center;
          }

          .main-header-layer {
            position: absolute;
            background: white;
            filter: blur(210px);
            inset: 80px -28px;
            z-index: 0;
            height: 200px;
            width: 100%;
          }

          .main-container,
          .involved-container {
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .main-header-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 948px;
          }

          .main-title,
          .main-title-highlight {
            font-size: 44px;
            line-height: var(--space-64);
            text-align: center;
            z-index: 2;
          }

          .main-title {
            color: var(--color-invert-component-tr-20);
          }

          .main-title-highlight {
            color: var(--color-secondary-solid-10);
          }

          .main-desc {
            margin-top: var(--space-32);
            margin-bottom: var(--space-48);
            color: var(--color-invert-component-tr-30);
            width: 786px;
            text-align: center;
            z-index: 2;
          }

          .video-wrapper {
            position: relative;
            margin-top: var(--space-96);
          }

          .video-player {
            --icon-color: var(--color-white-solid-10);
            --icon-container-color: var(--color-primary-solid-10);
            --width: 1000px;
            --height: 600px;
          }

          .video-image {
            width: 856px;
            height: 482px;
            object-fit: cover;
            border-radius: var(--space-36);
          }

          .video-image:hover {
            cursor: pointer;
            opacity: 0.5;
            transition: opacity 0.2s ease-in;
            background-color: var(--color-black-tr-60);
          }

          .research-card-container {
            display: flex;
            flex-direction: column;
            margin-top: var(--space-128);
            align-items: center;
          }

          .main-research-title {
            color: var(--color-invert-component-tr-30);
          }

          .main-research-desc {
            margin-top: var(--space-12);
            margin-bottom: var(--space-32);
            color: var(--color-invert-component-tr-40);
          }

          .researches-button {
            z-index: 2;
          }

          .research-card-wrapper {
            display: flex;
            flex-direction: column;
            row-gap: var(--space-24);
            align-items: center;
          }

          .card-more-btn {
            margin-top: var(--space-16);
          }

          .involved-section {
            --section-space: var(--space-128);
          }

          .involved-title {
            color: var(--color-invert-component-tr-30);
            margin-bottom: var(--space-40);
          }

          .product-cards-container {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-column-gap: var(--space-40);
          }

          .product-card {
            --card-width: 100%;
            --card-texts-align: center;
            --card-container-align: center;
            --img-width: 204px;
            --img-height: var(--space-128);
            --card-padding: var(--space-40);
            --img-margin-v: var(--space-24);
            --card-border-radius: var(--border-radius-40);
            --card-border: 1px solid var(--color-warning-solid-10);
          }

          .product-card:first-of-type {
            --card-border: 1px solid var(--color-pfm-shopping-main);
          }

          .product-card:last-of-type {
            --card-border: 1px solid var(--color-pfm-other-expenses-main);
          }

          .product-card-title {
            color: var(--color-invert-component-tr-20);
          }

          .product-card-description {
            margin-bottom: 0;
            text-align: center;
            color: var(--color-invert-component-tr-40);
          }

          .stage-section {
            padding-top: var(--space-40);
            padding-bottom: var(--space-128);
          }

          .stage-container {
            display: flex;
            column-gap: 152px;
          }

          .stage-text-container {
            display: flex;
            flex-direction: column;
            row-gap: var(--space-24);
          }

          .stage-title {
            color: var(--color-secondary-solid-10);
          }

          .stage-title-highlight {
            color: var(--color-invert-component-tr-30);
          }

          .stage-desc {
            color: var(--color-invert-component-tr-30);
          }

          .stage-cards-container {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-column-gap: var(--space-72);
            grid-row-gap: var(--space-80);
          }

          .stage-card {
            --card-width: 294px;
            --img-width: 136px;
            --img-height: var(--space-128);
            --card-padding: 0;
            --img-margin-v: var(--space-16);
            --card-border-radius: unset;
            --card-border: unset;
          }

          .research-types-section {
            background-color: #fcfcfc;
            z-index: 1;
            --border-space: 0;
            --content-max-width: auto;
            padding-top: var(--space-40);
          }

          .research-types-layer {
            position: absolute;
            background: var(--color-pfm-traveling-other);
            -webkit-filter: blur(150px);
            filter: blur(150px);
            top: 280px;
            bottom: 280px;
            left: -28px;
            right: -28px;
            z-index: -1;
            height: 560px;
            width: 100%;
            opacity: 0.5;
          }

          .research-types-header-wrapper, .info-header-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }

          .research-types-title {
            color: var(--color-invert-component-tr-30);
          }

          .research-types-desc {
            margin-top: var(--space-16);
            margin-bottom: var(--space-40);
            color: var(--color-invert-component-tr-40);
            text-align: center;
            max-width: 736px;
          }

          .tabs__content {
            margin-top: var(--space-32);
            box-sizing: border-box;
            border: 1px solid var(--color-invert-component-tr-70);
            border-radius: var(--border-radius-40);
          }

          .research-types-slider {
            --header-side-padding: 416px;
            --item-margin-right: var(--space-48);
          }
          .research-type-banner {
            --border-radius: var(--border-radius-40);
            --card-padding: var(--space-72) var(--space-64) var(--space-72) var(--space-48);
            --ilustration-width: 532px;
            --illustration-height: 492px;
            --max-height: 492px;
            --grid-column-space-between: 56px;
            --section-height: 100%;
            border-radius: var(--space-24);
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.10);
            margin-bottom: var(--space-6);
          }

          .research-type-free-content {
            width: 406px;
            --padding-top: var(--space-40);
            --text-description-color: var(--color-invert-component-tr-30);
          }

          .research-type-features-list {
            display: flex;
            flex-direction: column;
            row-gap: var(--space-12);
            margin: var(--space-32) 0;
          }

          .research-type-features-item {
            --border-color: transparent;
            --padding-left: 0;
            --padding-right: 0;
          }

          .research-type-features-icon {
            margin-right: var(--space-12);
            color: var(--color-success-solid-10);
          }

          .research-type-features-title {
            color: var(--color-invert-component-tr-30);
          }

          .register-section {
            --section-space: var(--space-128);
          }
          
          .info-section {
            padding-top: 144px;
          }
          
          .info-header-wrapper {
            row-gap: var(--space-24);
          }
          
          .info-title, .info-card-title {
            color: var(--text-primary);
          }

          .info-cards-wrapper {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-column-gap: var(--space-32);
            margin-top: var(--space-48);
          }
          
          .info-card {
            --width: 100%;
            --padding: var(--space-32);
            --border-radius: var(--border-radius-36);
            --border-color: var(--border-01);
            --media-width: 168px;
            --media-height: auto;
            --media-wrapper-align-content: start;
            --media-wrapper-border-radius: var(--border-radius-32);
            --gap: var(--space-20);
            --background-color: transparent;
          }
          
          .info-card-desc {
            color: var(--text-secondary);
          }

          .register-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: var(--space-64) var(--space-96);
            border-radius: var(--space-32);
            background-color: var(--color-pfm-traveling-background);
          }

          .register-title, .info-desc {
            color: var(--color-invert-component-tr-30);
          }

          .register-description {
            color: var(--color-black-tr-30);
            margin-top: var(--space-16);
            margin-bottom: var(--space-32);
            text-align: center;
          }

          .faq-section {
            padding-top: 0;
            padding-bottom: var(--space-128);
          }

          .faq {
            --justify-title: center;
          }

          @media (min-width: 1440px) and (max-width: 1700px)  {
            .head-1-img {
              left: 330px;
            }

            .head-2-img {
              right: 180px;
            }

            .head-3-img {
              left: 200px;
            }

            .head-4-img {
              right: 300px;
            }
            
            .research-type-section {
              --border-space: 0;
            }
            
            .research-types-slider {
              --header-side-padding: 156px;
              --item-margin-right: var(--space-36);
            }

            .research-types-section {
              --border-space: 0;
            }
          }

          @media (max-width: 1440px) {
            .head-1-img {
              left: 330px;
            }

            .head-2-img {
              right: 180px;
            }

            .head-3-img {
              left: 200px;
            }

            .head-4-img {
              right: 300px;
            }
          }

          @media (max-width: 1240px) {
            .head-1-img {
              left: 200px;
            }

            .head-2-img {
              right: 80px;
            }

            .head-3-img {
              left: 80px;
            }

            .head-4-img {
              right: 200px;
            }
          }

          @media (max-width: 1024px) {
            research-section {
              --border-space: var(--space-36);
            }

            .main-section {
              --section-space: var(--space-96);
            }

            .head-1-img,
            .head-2-img,
            .head-3-img,
            .head-4-img {
              display: none;
            }

            .main-desc {
              margin-bottom: var(--space-32);
            }

            .research-card-container {
              margin-top: var(--space-96);
            }

            .video-wrapper {
              margin-top: var(--space-80);
            }

            .video-player {
              --width: 856px;
              --height: 482px;
            }

            .research-card-wrapper {
              row-gap: var(--space-16);
            }

            .involved-section {
              padding-top: 0;
              padding-bottom: var(--space-128);
            }

            .involved-title {
              margin-bottom: var(--space-32);
            }

            .product-cards-container {
              grid-column-gap: var(--space-24);
            }

            .product-card {
              --card-padding: var(--space-32) var(--space-16);
            }

            .stage-section {
              padding-top: 0;
            }

            .stage-container {
              column-gap: var(--space-64);
            }

            .stage-text-container {
              width: 346px;
            }

            .stage-title {
              word-wrap: break-word;
            }

            .stage-cards-container {
              grid-column-gap: var(--space-32);
            }

            .stage-card {
              --card-width: 254px;
              --img-height: 102px;
            }

            .research-types-section {
              --border-space: unset;
            }

            .research-type-banner {
              --card-padding: var(--space-72) var(--space-40) var(--space-72) var(--space-48);
              --ilustration-width: 380px;
              --illustration-height: 350px;
              --max-height: 350px;
              --grid-column-space-between: var(--space-64);
            }

            .research-type-free-content {
              --padding-top: 0;
              width: unset;
            }
            
            .info-section {
              padding-top: var(--space-128);
            }
            
            .info-header-wrapper {
              row-gap: var(--space-12);
            }
            
            .info-cards-wrapper {
              grid-template-columns: repeat(1, 1fr);
              grid-row-gap: var(--space-32);
            }

            .register-section {
              --section-space: var(--space-96);
            }

            .register-container {
              padding: var(--space-48) var(--space-96);
            }
          }

          @media (max-width: 768px) {
            research-section {
              --border-space: 28px;
            }

            .main-header-container,
            .main-desc {
              width: unset;
            }

            .research-card-container {
              margin-top: var(--space-64);
            }

            .video-image {
              width: 590px;
              height: 380px;
            }

            .involved-section {
              padding-bottom: var(--space-96);
            }

            .involved-title {
              margin-bottom: var(--space-24);
            }

            .product-cards-container {
              grid-template-columns: repeat(1, 1fr);
              grid-row-gap: var(--space-24);
            }

            .product-card {
              --card-texts-align: flex-start;
              --card-container-align: flex-start;
              --img-width: 168px;
              --card-padding: var(--space-32);
              --img-margin-v: 0;
            }

            .product-card-description {
              text-align: start;
            }

            .stage-section {
              padding-bottom: var(--space-96);
            }

            .stage-container {
              flex-direction: column;
              row-gap: var(--space-32);
            }

            .stage-text-container {
              width: unset;
              row-gap: var(--space-12);
            }

            .stage-title,
            .stage-desc {
              text-align: center;
            }

            .stage-cards-container {
              grid-template-columns: repeat(1, 1fr);
              grid-row-gap: var(--space-32);
              padding: 0 var(--space-40);
            }

            .stage-card {
              --card-container-align: center;
            }
            
            .research-types-section {
              padding-top: 0;
            }

            .research-type-banner {
              --card-padding: var(--space-48) var(--space-40) var(--space-48) var(--space-48);
              --ilustration-width: 280px;
              --illustration-height: 258px;
              --max-height: 258px;
              --grid-column-space-between: var(--space-40);
            }

            .info-section {
              padding-top: var(--space-96);
            }
            
            .info-cards-wrapper {
              margin-top: var(--space-24);
            }
            
            .faq {
              --faq-padding: var(--space-24) var(--space-40);
            }
          }

          @media (max-width: 600px) {
            research-section {
              --border-space: var(--space-24);
            }

            .main-section {
              --section-space: var(--space-64);
            }

            .main-title,
            .main-title-highlight {
              font-size: var(--space-24);
              line-height: var(--space-40);
              text-align: center;
            }
            
            .researches-button {
              width: 100%;
            }

            .video-wrapper {
              margin-top: var(--space-64);
            }

            .video-player {
              --width: 760px;
              --height: 200px;
            }

            .video-image {
              width: 100%;
              height: unset;
            }

            .involved-section {
              padding-top: 0;
              padding-bottom: var(--space-64);
            }

            .involved-title {
              text-align: center;
            }

            .product-card {
              --card-texts-align: center;
              --card-container-align: center;
              --img-width: 204px;
              --card-padding: var(--space-32) var(--space-16);
              --img-margin-v: var(--space-24);
            }

            .product-card-description {
              text-align: center;
            }

            .stage-text-container {
              width: unset;
              row-gap: var(--space-24);
            }
            
            .stage-cards-container {
              padding: 0;
            }

            .stage-card {
              --card-container-align: flex-start;
              --img-width: var(--space-72);
              --img-height: var(--space-48);
              --card-horizontal-description: block;
            }

            .stage-card-title {
              margin-bottom: var(--space-8);
            }

            .research-types-section {
              --border-space: 0;
            }

            .research-types-desc {
              margin-bottom: var(--space-32);
            }
            
            .research-types-header-wrapper {
              margin: 0 var(--space-24);
            }
            
            .tabs-item:hover {
              --tab-box-shadow: unset;
            }
            
            .tabs-items:first-of-type {
              margin-left: var(--space-24);
            }

            .research-type-banner {
              --border-radius: 32px;
              --card-padding: var(--space-24) var(--space-24) var(--space-40) var(--space-24);
              --ilustration-width: 280px;
              --illustration-height: 258px;
              --max-height: 258px;
              --grid-column-space-between: var(--space-48);
            }

            .tabs__content {
              border-radius: 32px;
            }

            .research-type-banner-title {
              font-size: var(--space-24);
            }

            .research-type-features-list {
              margin: var(--space-24) 0;
            }

            .info-section {
              padding-top: var(--space-76, 76px);
            }

            .info-cards-wrapper {
              margin-top: var(--space-32);
              grid-row-gap: var(--space-20);
            }

            .info-card {
              min-width: 100%;
              --padding: var(--space-24) var(--space-24) var(--space-12) var(--space-24);
              --media-width: 100%;
              --media-height: 156px;
              --media-wrapper-justify-self: center;
              --gap: var(--space-16);
            }

            .register-section {
              --section-space: var(--space-64);
            }

            .register-container {
              border-radius: var(--space-32);
              padding: var(--space-64) var(--space-24);
            }

            .faq-section {
              padding-bottom: var(--space-64);
            }

            .faq {
              --faq-padding: var(--space-24);
            }
          }
        `;
    }

    render() {
        return html`
            ${this.data?.mainBanner && this.data?.mainBanner?.title && this.data?.mainBanner?.titleHighlight ?
                html`<research-section class="main-section">
                      <div class="main-container">
                          <div class="main-header-container">
                              <div class="main-header-layer"></div>
                              <bd-font type="h2" class="main-title">
                                  ${unsafeHTML(
                                      this.replaceMainTitle(
                                          this.data.mainBanner.title,
                                          this.data.mainBanner.titleHighlight
                                      )
                                  )}
                              </bd-font>
                              <bd-font type="subtitle" class="main-desc">
                                  ${this.data?.mainBanner?.description}
                              </bd-font>
                              <bd-standard-button
                                      type="primary"
                                      class="researches-button"
                                      suffix-icon="bd:chevron_right"
                                      .href="${this.data?.mainBanner?.showMoreButtonUrl?.link}"
                                      .target="${this.data?.mainBanner?.showMoreButtonUrl?.target}">
                                  ${this.data?.mainBanner?.btnLabel}
                              </bd-standard-button>
                          </div>
                          ${this.data?.mainBanner?.videoUrl?.link && this.data?.mainBanner?.videoImg?.url ?
                              html`<div class="video-wrapper">
                                    <img
                                        class="video-image"
                                        src="${this.data.mainBanner.videoImg.url}"
                                        @click=${() => this._playVideo('main-video')}
                                    />
                                    <bd-video-player
                                        id="main-video"
                                        video-link="${this.data.mainBanner.videoUrl.link}"
                                    >
                                    </bd-video-player>
                                </div>` :
                              ''}
                      </div>
                      <img class="head-1-img" src="assets/main-icons/Head_1.png" alt="Head_1" />
                      <img class="head-2-img" src="assets/main-icons/Head_2.png" alt="Head_2" />
                      <img class="head-3-img" src="assets/main-icons/Head_3.png" alt="Head_3" />
                      <img class="head-4-img" src="assets/main-icons/Head_4.png" alt="Head_4" />
                      ${this.researchCards?.length > 0 ?
                          html` <div class="research-card-container">
                                ${this.data?.mainBanner?.videoUrl?.link && this.data?.mainBanner?.videoImg?.url ? html`
                                            <bd-font type="h2" class="main-research-title">
                                    ${this.data?.mainBanner?.researchTitle}
                                </bd-font>
                                <bd-font type="body1" class="main-research-desc">
                                    ${this.data?.mainBanner?.researchDescription}
                                </bd-font>` : ''}
                                <div class="research-card-wrapper">
                                    ${this.researchCards.map(
                                        (card) => html`
                                            <research-card
                                                short-version
                                                title="${card?.title}"
                                                description="${card?.description}"
                                                gift-text="${card?.badge}"
                                                duration-text="${card?.duration}"
                                                duration-icon="bd:time_clock"
                                                ?has-footer="${this.data?.mainBanner?.cardMoreButtonLabel ||
                                                    card?.registration?.link}">
                                                ${this.data?.mainBanner?.cardMoreButtonLabel ?
                                                    html` <bd-standard-button
                                                          type="text-primary"
                                                          slot="more-button"
                                                          size="medium"
                                                          .href="${`/${this.lang}/research/details/${card?._id}`}"
                                                      >
                                                          ${this.data.mainBanner.cardMoreButtonLabel}
                                                      </bd-standard-button>` :
                                                    ''}
                                                ${card?.registration?.link ?
                                                    html` <bd-standard-button
                                                          type="primary"
                                                          slot="register-button"
                                                          size="medium"
                                                          @click="${() => {
                                                              this.sendAnalyticsEvent({
                                                                  eventName: 'Research_Bog',
                                                                  eventAction: 'register_click',
                                                                  isNonInteraction: false,
                                                                  sendToFB: true,
                                                              });
                                                              this.openModal(card.registration);
                                                          }}"
                                                      >
                                                          ${this.data.mainBanner.cardRegisterButtonLabel}
                                                      </bd-standard-button>` :
                                                    ''}
                                            </research-card>
                                        `
                                    )}
                                    ${this._totalItems > this._researchCardsLimit ? html`
                                        <bd-standard-button
                                            class="card-more-btn"
                                            type="text-primary"
                                            suffix-icon="bd:chevron_right"
                                            .href="${this.data?.mainBanner?.showMoreButtonUrl?.link}"
                                            .target="${this.data?.mainBanner?.showMoreButtonUrl?.target}"
                                        >
                                            ${this.data?.mainBanner?.showMoreButtonLabel}
                                        </bd-standard-button>` : ''}
                                </div>
                            </div>` :
                          ''}
                  </research-section>` :
                ''}
            ${this.data?.involvedBanner?.title && this.data?.involvedBanner?.cards.length > 0 ?
                    html`<research-section class="involved-section" no-pad-top>
                        <div class="involved-container">
                            <bd-font type="h2" class="involved-title"> ${this.data.involvedBanner.title} </bd-font>
                            <div class="product-cards-container">
                                ${this.data.involvedBanner.cards.map(
                                        (card) => html`
                                            <research-product-promo-card
                                                    class="product-card"
                                                    header="${card?.title}"
                                                    description="${card?.description}"
                                                    imgurl="${card?.image?.url}"
                                                    static
                                                    reversed
                                                    show-description
                                                    ?horizontal="${this._isTablet && !this._isMobile}"
                                            >
                                                <bd-font class="product-card-title" type="title" slot="title">
                                                    <h4>${card?.title}</h4>
                                                </bd-font>
                                                <bd-font class="product-card-description" type="body2" slot="description">
                                                    <span>${card?.description}</span>
                                                </bd-font>
                                            </research-product-promo-card>
                                        `
                                )}
                            </div>
                        </div>
                    </research-section>` :
                    ''}
            ${this.data?.stageBanner?.title &&
            this.data?.stageBanner?.titleHighlight &&
            this.data?.stageBanner?.cards.length > 0 ?
                    html`<research-section class="stage-section">
                        <div class="stage-container">
                            <div class="stage-text-container">
                                <bd-font class="stage-title" type="h2">
                                    ${this.data.stageBanner.titleHighlight}
                                    <span class="stage-title-highlight">${this.data.stageBanner.title}<span>
                                </bd-font>
                                <bd-font class="stage-desc" type="body1">
                                    ${this.data?.stageBanner?.description}
                                </bd-font>
                            </div>
                            <div class="stage-cards-container">
                                ${this.data.stageBanner.cards.map(
                                        (card) => html`
                                            <research-product-promo-card
                                                    class="stage-card"
                                                    header="${card?.title}"
                                                    description="${card?.description}"
                                                    imgurl="${card?.image?.url}"
                                                    static
                                                    reversed
                                                    show-description
                                                    ?horizontal="${this._isTablet}"
                                            >
                                                <bd-font class="stage-card-title" type="title" slot="title">
                                                    <h4>${card?.title}</h4>
                                                </bd-font>
                                                <bd-font class="stage-card-description" type="body2" slot="description">
                                                    <span>${card?.description}</span>
                                                </bd-font>
                                            </research-product-promo-card>
                                        `
                                )}
                            </div>
                        </div>
                    </research-section>` :
                    ''}
            ${this.data?.researchTypes &&
            this.data?.researchTypes?.slider?.length > 0 &&
            this.data?.researchTypes?.tabSelector?.length > 0 ?
                    html`
                        <research-section class="research-types-section" no-pad-top no-pad-bottom>
                            <div class="research-types-header-wrapper">
                                <bd-font type="h2" class="research-types-title">
                                    ${this.data?.researchTypes?.title}
                                </bd-font>
                                <bd-font type="body1" class="research-types-desc">
                                    ${this.data?.researchTypes?.description}
                                </bd-font>
                            </div>
                            <div class="research-types-layer"></div>
                            ${this._isLaptop ?
                                    this.getResearchTypesTabs(this.data?.researchTypes?.tabSelector) :
                                    this.getResearchTypesSlider(this.data?.researchTypes?.slider)}
                        </research-section>
                    ` :
                    ''}
            ${this.data?.infoSection?.title &&
            this.data?.infoSection?.cards?.length > 0 ?
                    html`
                        <research-section class="info-section" no-pad-bottom>
                            <div class="info-header-wrapper">
                                <bd-font type="h2" class="info-title">
                                    ${this.data?.infoSection?.title}
                                </bd-font>
                                ${this.data?.infoSection?.description && !this._isTablet ? html`
                                    <bd-font type="body1" class="info-desc">
                                        ${this.data.infoSection.description}
                                    </bd-font>
                                ` : ''}
                            </div>
                            <div class="info-cards-wrapper">
                                ${this.data.infoSection.cards.map((item) => html`
                                    <bd-major-card type="${this._isMobile ? 'top' : 'right'}" class="info-card"
                                                  @click="${() => window.open(item?.buttonUrl?.link,
                                                          item?.buttonUrl?.target)}">
                                        <bd-font class="info-card-title" type="title" slot="title">
                                            ${item?.title}
                                        </bd-font>
                                        ${!this._isMobile ? html`
                                            <bd-font class="info-card-desc" type="body1" slot="body" fixed>
                                            ${item?.description}
                                            </bd-font>
                                        ` : ''}
                                        <img slot="media" src="${item?.image?.url}" alt="${item?.image?.alt}"/>
                                        <bd-standard-button 
                                                slot="bottom" 
                                                type="text-low" 
                                                size="small"
                                                prefix-icon="bd:external">
                                            ${item?.buttonLabel}
                                        </bd-standard-button>
                                    </bd-major-card>
                                `)}
                            </div>
                        </research-section>
                    ` :
                    ''}
            ${this.data?.registerBanner && this.data?.registerBanner?.title ?
                    html`<research-section class="register-section">
                        <div class="register-container">
                            <bd-font type="h2" class="register-title">
                                <h3>${this.data.registerBanner.title}</h3>
                            </bd-font>

                            <bd-font type="body1" class="register-description">
                                <span>${this.data.registerBanner?.description}</span>
                            </bd-font>

                            <bd-standard-button type="primary"
                                                class="register-btn"
                                                suffix-icon="bd:chevron_right"
                                                @click="${()=> this.sendAnalyticsEvent({
                                                    eventName: 'Research_Bog',
                                                    eventAction: 'all_research_click',
                                                    isNonInteraction: false,
                                                    sendToFB: true,
                                                })}"
                                                }"
                                                .href="${this.data.registerBanner?.btnUrl?.link}"
                                                .target="${this.data.registerBanner?.btnUrl?.target}">
                                ${this.data?.registerBanner?.btnLabel}
                            </bd-standard-button>
                        </div>
                    </research-section>` :
                    ''}
            ${this.data?.faq && this.data?.faq?.faqTitle && this.data?.faq.faq?.length > 0 ?
                    html`
                        <research-section class="faq-section">
                            <research-faq class="faq" stroke title-type="h2" .data="${this.data.faq}"> </research-faq>
                        </research-section>
                    ` :
                    ``}
        `;
    }

    constructor() {
        super();
        this.data = {};
        this._researchCardsLimit = 3;
        this._isLaptop = window.matchMedia(`(max-width: 1400px)`).matches;
        this._isTablet = window.matchMedia(`(max-width: 768px)`).matches;
        this._isMobile = window.matchMedia(`(max-width: 600px)`).matches;
    }

    static get properties() {
        return {
            data: {
                type: Object,
            },
            researchCards: {
                type: Array,
            },
            _researchCardsLimit: {
                type: Number,
            },
            _totalItems: {
                type: Number,
            },
        };
    }

    connectedCallback() {
        super.connectedCallback();
        if (this.ref) {
            const {$ref, $id} = this.ref;
            this.apiCall(`main/${$ref}/${$id}`)
                .then((res) => {
                    this.data = res.json.data;

                    if (this.data?.mainBanner?.researchCards?.collection &&
                        this.data.mainBanner.researchCards.listId) {
                        const {collection, listId} = this.data.mainBanner.researchCards;

                        this.apiCall(`catalog/get-items/${collection}/${listId}?limit=${this._researchCardsLimit}`)
                            .then((res) => {
                                this.researchCards = res.json.data.items;
                                this._totalItems = res.json.data.total;
                            })
                            .catch((err) => {
                                console.error(err);
                            });
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        }
    }

    _playVideo(id) {
        this.shadowRoot.getElementById(`${id}`).showPlayer();
    }

    replaceMainTitle(oldTitle, newTitle) {
        return `${oldTitle.replace('%s', `<span class="main-title-highlight">${newTitle}</span>`)}`;
    }

    getResearchTypesSlider(cards) {
        return html`
            <research-slider
                    items-number="${cards.length}"
                    ?is-loading="${false}"
                    class="research-types-slider"
                    item-margin-right-default="${16}"
                    header-side-padding="312"
                    .cards="${cards}"
                    @tab-click="${({detail}) => this.sendAnalyticsEvent({
                        eventName: 'Research_Bog',
                        eventAction: 'research_type_click',
                        eventLabel: detail?.value,
                        isNonInteraction: false,
                        sendToFB: true,
                    })}"
            >
                ${cards.map(
                        (card) => html`
                            <bd-section-template class="research-type-banner" ?with-video=${card?.primaryUrl?.link}>
                                <img slot="illustration" class="research-type-illustration" src="${card?.image?.url}" />
                                <bd-video-player
                                        class="video-player"
                                        id="video"
                                        video-link="${card.primaryUrl.link}"
                                        slot="video"
                                >
                                </bd-video-player>
                                <bd-free-content slot="free-content" class="research-type-free-content">
                                    <bd-font slot="title" type="h4" class="research-type-banner-title">
                                        <span>${card?.title}</span>
                                    </bd-font>
                                    <bd-font slot="description" type="body1" class="research-type-banner-desc">
                                        <span>${card?.description}</span>
                                    </bd-font>
                                    ${card?.features ?
                                            html`
                                                <div slot="description" class="research-type-features-list">
                                                    ${card.features.map(
                                                            (feature) => html`
                                                                <bd-list-item class="research-type-features-item" static>
                                                                    <bd-icon
                                                                            class="research-type-features-icon"
                                                                            icon="${feature?.icon}"
                                                                            slot="left"
                                                                    ></bd-icon>
                                                                    <bd-font
                                                                            class="research-type-features-title"
                                                                            slot="center"
                                                                            type="body2"
                                                                    >
                                                                        ${feature?.title}
                                                                    </bd-font>
                                                                </bd-list-item>
                                                            `
                                                    )}
                                                </div>
                                            ` :
                                            ''}
                                    ${card?.primaryUrl?.link && card?.primaryLabel ?
                                            html`
                                                <bd-standard-button
                                                        class="research-type-features-button"
                                                        type="text-low"
                                                        prefix-icon="bd:play_outline"
                                                        slot="button"
                                                        @click=${() => this._playVideo('video')}
                                                >
                                                    ${card.primaryLabel}
                                                </bd-standard-button>` :
                                            ''}
                                </bd-free-content>
                            </bd-section-template>
                        `
                )}
            </research-slider>
        `;
    }

    getResearchTypesTabs(tabSelector) {
        return html`
            <research-tab-selector select=${tabSelector[0].key} class="tabs">
                ${tabSelector.map(
                        (tab) => html`
                            <bd-tab slot="tab" name=${tab?.key} 
                                    @click="${()=> this.sendAnalyticsEvent({
                                        eventName: 'Research_Bog',
                                        eventAction: 'research_type_click',
                                        eventLabel: tab?.key,
                                        isNonInteraction: false,
                                        sendToFB: true,
                                    })}" 
                                    class="tabs-items"> ${tab?.title} </bd-tab>
                            <div slot="content" name=${tab?.key} class="tabs__content">
                                ${tab.cards ? tab.cards.map(
                                        (card) => html`
                                            <bd-section-template
                                                    class="research-type-banner"
                                                    ?reversed=${this._isMobile}
                                                    ?vertical=${this._isMobile}
                                                    ?with-video=${card?.primaryUrl?.link}
                                            >
                                                <bd-video-player
                                                        id="video"
                                                        video-link="${card?.primaryUrl?.link}"
                                                        slot="video"
                                                >
                                                </bd-video-player>
                                                <img
                                                        slot="illustration"
                                                        class="research-type-illustration"
                                                        src="${card?.image?.url}"
                                                />
                                                <bd-free-content slot="free-content" class="research-type-free-content">
                                                    <bd-font slot="title" type="h4" class="research-type-banner-title">
                                                        <span>${card?.title}</span>
                                                    </bd-font>
                                                    <bd-font slot="description" type="body1" class="research-type-banner-desc">
                                                        <span>${card?.description}</span>
                                                    </bd-font>
                                                    ${card?.features ?
                                                            html`
                                                                <div slot="description" class="research-type-features-list">
                                                                    ${card.features.map(
                                                                            (feature) => html`
                                                                                <bd-list-item
                                                                                        class="research-type-features-item"
                                                                                        static
                                                                                >
                                                                                    <bd-icon
                                                                                            class="research-type-features-icon"
                                                                                            icon="${feature?.icon}"
                                                                                            slot="left"
                                                                                    ></bd-icon>
                                                                                    <bd-font
                                                                                            class="research-type-features-title"
                                                                                            slot="center"
                                                                                            type="body2"
                                                                                    >
                                                                                        ${feature?.title}
                                                                                    </bd-font>
                                                                                </bd-list-item>
                                                                            `
                                                                    )}
                                                                </div>
                                                            ` :
                                                            ''}
                                                    ${card?.primaryUrl?.link && card?.primaryLabel ?
                                                            html`
                                                                <bd-standard-button
                                                                        class="research-type-features-button"
                                                                        type="text-low"
                                                                        prefix-icon="bd:play_outline"
                                                                        slot="button"
                                                                        @click=${() => this._playVideo('video')}
                                                                >
                                                                    ${card.primaryLabel}
                                                                </bd-standard-button>
                                                            ` :
                                                            ''}
                                                </bd-free-content>
                                            </bd-section-template>
                                        `
                                ) : ''}
                            </div>
                        `
                )}
            </research-tab-selector>
        `;
    }

    openModal(item) {
        const options = {
            element: this._infoModalContent(item),
            sticky: false,
            beforeClose: null,
        };
        BdModal.open(options).catch(() => {});
    }

    _closeModal() {
        BdModal.close();
    }

    _infoModalContent(item) {
        return html`
            <research-info-modal
                .data="${this.data?.infoModal}"
                .registrationUrl="${item}"
                @close-info-modal="${this._closeModal}"
            ></research-info-modal>
        `;
    }
}

window.customElements.define(researchMain.is, researchMain);
